import { VariantType } from 'notistack'
import { DataRoomUploadResult } from 'src/types/projects'
import { formatCount } from './formatCount'

/** "a, b, c and 4 more" — the first few names of a list that may be long. */
const formatNameList = (names: string[], shown = 3): string => {
  const head = names.slice(0, shown).join(', ')
  return names.length > shown ? `${head} and ${names.length - shown} more` : head
}

/** The end-of-upload snackbar: what landed, what was already there, what failed and how to retry. */
export const describeUploadResult = (
  { uploaded, failed, alreadyExisting, indexingFailed }: DataRoomUploadResult,
  retryHint: string,
): { message: string; variant: VariantType } => {
  const total = uploaded + failed.length + alreadyExisting.length
  const lines = [
    uploaded === total ? `Uploaded ${formatCount(uploaded, 'file')}.` : `Uploaded ${uploaded} of ${total}.`,
    alreadyExisting.length > 0 && `Already there, skipped: ${formatNameList(alreadyExisting)}.`,
    failed.length > 0 && `Failed: ${formatNameList(failed)}. ${retryHint}`,
    indexingFailed && 'COPA could not index the new files yet.',
  ]
  const variant = failed.length > 0 || indexingFailed ? 'warning' : alreadyExisting.length > 0 ? 'info' : 'success'
  return { message: lines.filter(Boolean).join(' '), variant }
}
